import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import WarningIcon from '@mui/icons-material/Warning';
import { TableCell, TableRow } from '@mui/material';

import {
    loadContractDetailsForContractId,
    loadServiceDetailsForContractId
} from '../../../store/directusService';
import { loadParticipantByPtCode } from '../../../store/participantService';

import classes from '../../../commonStyles/tables.module.css';
import local from '../homeStyles/futureAppointments.module.css';

const AppointmentTableRow = ({ row }) => {
    // HOOKS
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // LOCAL STATE
    const [isPTRequestSent, setIsPTRequestSent] = useState(false);

    // STORE STATE
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );
    const contractDetailsById = useSelector(
        (state) => state.entities.directusService.contractDetailsById
    );
    const servicesByContractId = useSelector(
        (state) => state.entities.directusService.servicesByContractId
    );

    // USE EFFECTS
    useEffect(() => {
        if (isPTRequestSent && currentParticipant?.ptCode === row.ptCode) {
            if (!(currentParticipant.contractId in contractDetailsById))
                dispatch(loadContractDetailsForContractId(currentParticipant.contractId));
            if (!(currentParticipant.contractId in servicesByContractId))
                dispatch(loadServiceDetailsForContractId(currentParticipant.contractId));
        }
    }, [isPTRequestSent, currentParticipant]);

    useEffect(() => {
        if (
            isPTRequestSent &&
            currentParticipant?.ptCode === row.ptCode &&
            contractDetailsById[currentParticipant.contractId] &&
            servicesByContractId[currentParticipant.contractId]
        )
            navigate('/edit_participant');
    }, [isPTRequestSent, contractDetailsById, servicesByContractId, currentParticipant]);

    // HELPER FUNCTIONS
    const onClickPTCode = () => {
        if (!row?.ptCode) return;
        dispatch(loadParticipantByPtCode(row.ptCode));
        setIsPTRequestSent(true);
    };

    // RENDER
    return (
        <TableRow hover className={classes.basicRowStripes}>
            <TableCell className={classes.rowLink} onClick={onClickPTCode}>
                {row.ptCode}
            </TableCell>
            <TableCell>{row.name}</TableCell>
            <TableCell>{row.participantStatus}</TableCell>
            <TableCell>
                {row.lastAppointment || (
                    <span className={local.warningIcon}>
                        <WarningIcon />
                    </span>
                )}
            </TableCell>
            <TableCell>
                {row.attendanceStatus || <span className={local.emptyCell}> - </span>}
            </TableCell>
            <TableCell>
                {row.lastAppointmentDate || <span className={local.emptyCell}> - </span>}
            </TableCell>
            <TableCell>
                {row.nextAppointment || (
                    <span className={local.warningIcon}>
                        <WarningIcon />
                    </span>
                )}
            </TableCell>
            <TableCell>
                {row.nextAppointmentDate || <span className={local.emptyCell}> - </span>}
            </TableCell>
        </TableRow>
    );
};

AppointmentTableRow.propTypes = {
    row: PropTypes.object.isRequired
};

export default AppointmentTableRow;
